import { createUseStyles } from 'react-jss';
import { FontWeight, ITheme } from '@quicktools/shared-components';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {},
    heading: {
      color: '#000000',
      fontSize: '14px',
      lineHeight: '16px',
      fontWeight: FontWeight.Bold,
      marginBottom: 12,
    },
  }),
  { name: 'category-filter' },
);
